import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core'
import {CanvasStoreComponent} from "../canvas-store/canvas-store.component";
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {isCanvasStoreAllowed} from '../../../configs/view_only';

declare const Yiit;

@Component({
  selector: 'app-mobile-last-header-btns',
  templateUrl: './mobile-last-header-btns.component.html',
  styleUrls: ['./mobile-last-header-btns.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MobileLastHeaderBtnsComponent implements OnInit {

  public isOpened: boolean = false;
  public Yiit = Yiit;
  public isCanvasStoreAllowed = isCanvasStoreAllowed;

  constructor(private cd: ChangeDetectorRef, private im:ItemManagerService) { }
  @ViewChild(CanvasStoreComponent, {static: false})
  protected canvasStoreComponent: CanvasStoreComponent;
  ngOnInit() {
  }

  public closeMenu(){
    this.isOpened = false;
  }

  toggleDropDown(){
    this.isOpened = !this.isOpened;
  }

  openModal(){
    this.closeMenu();
    if (this.isCanvasStoreAllowed){
      this.canvasStoreComponent.show();
    }
  }

  moveToShareUrl(){
    this.closeMenu();
    let basePath = window.location.hostname;
    let resultPathName = window.location.pathname;
    resultPathName = resultPathName.substr(0, resultPathName.indexOf('/event/')+7);
    resultPathName = basePath+resultPathName+'update/'+window['EVENT_ID']+'#sharing-tab';
    location.href = location.protocol +'//'+resultPathName;
  }


}
